/**
 * Light and dark themes (CLAUDE.md section 7). The person's choice is kept
 * in this browser only; "system" follows the device.
 */
import { createContext, useContext } from "react";

export type ThemeChoice = "light" | "dark" | "system";

export const THEME_STORAGE_KEY = "scrutiny.theme";

export function storedTheme(): ThemeChoice {
  try {
    const value = window.localStorage.getItem(THEME_STORAGE_KEY);
    return value === "light" || value === "dark" ? value : "system";
  } catch {
    return "system"; // storage blocked: fall back quietly
  }
}

export function applyTheme(choice: ThemeChoice): void {
  const dark =
    choice === "dark" ||
    (choice === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.dataset.theme = dark ? "dark" : "light";
}

export interface ThemeValue {
  choice: ThemeChoice;
  setChoice: (choice: ThemeChoice) => void;
}

export const ThemeContext = createContext<ThemeValue>({
  choice: "system",
  setChoice: () => undefined,
});

export function useTheme(): ThemeValue {
  return useContext(ThemeContext);
}
